import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { IBtn } from '../interfaces/btn.interface';
import { Color } from '../../utils/color.enum';

@Component({
  selector: 'app-generic-form-btn',
  templateUrl: './generic-btn.component.html',
  styleUrls: ['./generic-btn.component.scss']
})
export class GenericFormBtnComponent implements OnInit {

  @Output() pressBtn: EventEmitter<string> = new EventEmitter();

  @Input() btns: Array<IBtn> = [
    {
      key: 'sendForm',
      texto: 'Permitir',
      tipo: 'raised',
      color: Color.ACCENT,
      icono: 'check',
      tooltip: 'Enviar formulario',
      disabled: false,
    },
    {
      key: 'clearForm',
      texto: 'Denegar',
      tipo: 'raised',
      color: null,
      icono: 'clear',
      tooltip: 'Cancelar acción',
      disabled: false,

    }
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

  actionBtn(action: string): void {
    this.pressBtn.emit(action);
  }

}
